import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import { Table, PageHeader, Modal, FormField } from '../../../components/UI';
import toast from 'react-hot-toast';

export default function DesignationMaster() {
  const [items, setItems] = useState([]);
  const [depts, setDepts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ dept_id:'', designation_name:'', designation_code:'' });
  const [saving, setSaving] = useState(false);

  const load = () => {
    setLoading(true);
    Promise.all([api.get('/masters/designations'), api.get('/masters/departments')])
      .then(([d, dts]) => { setItems(d.designations||[]); setDepts(dts.departments||[]); })
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const handleSave = async (e) => {
    e.preventDefault(); setSaving(true);
    try { await api.post('/masters/designations', form); toast.success('Created'); setModal(false); load(); }
    catch { toast.error('Save failed'); } finally { setSaving(false); }
  };

  const columns = [
    {key:'designation_name',label:'Designation Name'},
    {key:'designation_code',label:'Code'},
    {key:'dept_name',label:'Department'},
    {key:'is_active',label:'Status',render:r=><span className={r.is_active?'text-green-600':'text-red-500'}>{r.is_active?'Active':'Inactive'}</span>},
  ];

  return (
    <div>
      <PageHeader title="Designation Master" actions={<button className="btn-primary" onClick={()=>{ setForm({dept_id:'',designation_name:'',designation_code:''}); setModal(true); }}>+ Add Designation</button>} />
      <div className="card overflow-hidden p-0"><Table columns={columns} data={items} loading={loading} /></div>
      <Modal isOpen={modal} onClose={()=>setModal(false)} title="Add Designation">
        <form onSubmit={handleSave} className="space-y-4">
          <FormField label="Department">
            <select className="form-select" value={form.dept_id} onChange={e=>setForm(p=>({...p,dept_id:e.target.value}))} required>
              <option value="">Select Department</option>
              {depts.map(d=><option key={d.id} value={d.id}>{d.dept_name}</option>)}
            </select>
          </FormField>
          <FormField label="Designation Name" required><input className="form-input" value={form.designation_name} onChange={e=>setForm(p=>({...p,designation_name:e.target.value}))} required /></FormField>
          <FormField label="Code"><input className="form-input" value={form.designation_code} onChange={e=>setForm(p=>({...p,designation_code:e.target.value}))} /></FormField>
          <div className="flex gap-3 justify-end"><button type="button" className="btn-secondary" onClick={()=>setModal(false)}>Cancel</button><button type="submit" className="btn-primary" disabled={saving}>{saving?'Saving...':'Save'}</button></div>
        </form>
      </Modal>
    </div>
  );
}
